import React from 'react';
import styled from 'styled-components';
import { greyColours } from '../../styles';
import TrustpilotWidget from '../TrustpilotWidget';
import paymentIcons from '../../images/payment-icons.img.svg';

const StyledPaymentInfo = styled.div`
  margin: 30px 0;
  text-align: center;
`;

const StyledPaymentInfoText = styled.p`
  color: ${greyColours.darkPurplishGrey};
`;

const StyledPaymentInfoIcons = styled.img`
  margin: 12px 0 20px;
  width: 280px;
`;

const AcceptedPayments = ({ removeInfoText, ...props }) => (
  <StyledPaymentInfo {...props}>
    {!removeInfoText && (
      <StyledPaymentInfoText>
        We accept the following payments
      </StyledPaymentInfoText>
    )}
    <StyledPaymentInfoIcons
      src={paymentIcons}
      alt="Apple Pay, PayPal, Mastercard, Visa, Maestro and Amex"
      loading="lazy"
    />
    <TrustpilotWidget type="micro-star" isTest={true} />
  </StyledPaymentInfo>
);

export default AcceptedPayments;
